import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { isToastieAction } from '@era/stores';
import { tap } from 'rxjs';
import { ToastService } from './toast.service';

@Injectable()
export class ToastEffect {
  constructor(
    private readonly actions$: Actions,
    private readonly toastService: ToastService
  ) {}

  toastEffect$ = createEffect(
    () => {
      return this.actions$.pipe(
        tap((action) => {
          if (isToastieAction(action)) {
            this.toastService.showToastie(action.toast);
          }
        })
      );
    },
    { dispatch: false }
  );
}
